import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyVideo = loadable(() => import(/* webpackChunkName: "content/guestSiteVideo" */ '.'), 'Video');
